import React from 'react';
import PropTypes from 'prop-types';
import RssFeeds from '../../common/components/rssFeeds';
import CardGroup1 from './cardGroup';
import LayoutWrapper from './layoutWrapper';
import { CARD_SLIDE_HEIGHT } from './constants';

class RssFeeds1 extends RssFeeds {
  static get propTypes() {
    return {
      backgroundImage: PropTypes.string
    };
  }

  constructor() {
    super(...arguments);
    this.cardGroupComponent = CardGroup1;

    // Give loading animation the same height as a content card so on
    // initial load the background image is the right size.
    if (this.props.backgroundImage) {
      this.extraLoadingContainerStyles = {
        minHeight: CARD_SLIDE_HEIGHT[this.props.siteFontScale]
      };
    }
  }

  render() {
    return <LayoutWrapper { ...this.props }>{ super.render() }</LayoutWrapper>;
  }
}

export default RssFeeds1;
